import { Button as DSButton } from '@backend/lib-design-system';
import { styled } from 'styled-components';

export const Button = styled(DSButton)`
  background-color: #4040b4 !important;

  &:hover {
    background-color: #a1a2ff !important;
  }

  &:active {
    background-color: #272356 !important;
  }
`;
